import React, { useContext } from "react";
import { Container, Grid, Box } from "@mui/material";
import Mou from "./inc/Mou";
import ResetPassword from "./inc/ResetPassword";
import SchoolUsers from "./inc/SchoolUsers";
import UserProfileRequest from "./inc/UserProfileRequest";
import { SchoolContext } from "../../../config/SchoolContext";
import { faUser } from "@fortawesome/free-solid-svg-icons";
import CcpSchoolBreadCrumbs from "../../Layout/CcpSchoolBreadCrumbs";
import { useTheme } from "@mui/material/styles";
import GetCoordIds from "../../CcpConstants/GetCoordIds";

const CcpSchoolAccountProfile = () => {
  const { schoolId } = useContext(SchoolContext);
  const theme = useTheme();
  const linkColor = theme.palette.mode === "dark" ? "white" : "black";

  const {
    pathwayEmail,
    opEmail,
    loading: emailsLoading,
    error: emailsError,
  } = GetCoordIds(schoolId);

  const pageName = "Account Profile";
  const icon = faUser;

  if (emailsLoading) {
    return <div>Loading...</div>; // Or a more suitable loading indicator
  }

  if (emailsError) {
    return <div>Error: {emailsError.message}</div>;
  }

  return (
    <Container sx={{ marginTop: "100px" }}>
      <Box sx={{ flexGrow: 1 }}>
        <CcpSchoolBreadCrumbs pageName={pageName} icon={icon} />
        <Grid container spacing={2}>
          <Grid item xs={12}></Grid>
          <Grid item xs={12}>
            <UserProfileRequest
              schoolId={schoolId}
              pathwayEmail={pathwayEmail}
              opEmail={opEmail}
            />
          </Grid>
          <Grid item xs={6}>
            <Mou schoolId={schoolId} linkColor={linkColor} />
          </Grid>
          <Grid item xs={6}>
            <ResetPassword />
          </Grid>
          <Grid item xs={6}></Grid>{" "}
          <Grid item xs={12}>
            <SchoolUsers />
          </Grid>
        </Grid>
      </Box>
    </Container>
  );
};

export default CcpSchoolAccountProfile;
